<div class="cet-help-bar">
  <!-- <strong
    >Having troubles?
    <span style="margin-inline: 0.2rem; color: #65b045; text-decoration: underline;">
      Visit website</span
    ></strong
  > -->
  <!-- <app-lang-toggler></app-lang-toggler> -->
</div>
